// extracted by mini-css-extract-plugin
export default {"flex":"nationalView_flex__pJCrM","map_container":"nationalView_map_container__Ygk8D","map":"nationalView_map__ZqLRq","table_container":"nationalView_table_container__FN8e9"};